(function () {
  var root = document.querySelector('[data-mc-lager]');
  if (!root) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- reveal ---------- */
  var reveals = root.querySelectorAll('[data-reveal]');
  if ('IntersectionObserver' in window && !reduce) {
    root.querySelectorAll('.mc-lg-addon-grid [data-reveal]').forEach(function (el, i) {
      el.style.setProperty('--d', (i * 70) + 'ms');
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---------- parallax (inner img) ---------- */
  if (!reduce) {
    var nodes = [];
    root.querySelectorAll('[data-parallax]').forEach(function (el) {
      var img = el.querySelector('img');
      if (img) nodes.push(img);
    });
    var ticking = false;
    function update() {
      ticking = false;
      var vh = window.innerHeight;
      nodes.forEach(function (img) {
        var r = img.getBoundingClientRect();
        if (r.bottom < -50 || r.top > vh + 50) return;
        var prog = (r.top + r.height / 2 - vh / 2) / vh;
        img.style.transform = 'translate3d(0,' + (prog * -26).toFixed(1) + 'px,0) scale(1.07)';
      });
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  /* ---------- hero video: sound while in view, stop when scrolled past ---------- */
  var heroVid = root.querySelector('[data-mc-lg-hero-video]');
  var heroEl = root.querySelector('.mc-lg-hero');
  if (heroVid) {
    var hadGesture = false;
    function unmuteHero() { try { heroVid.muted = false; heroVid.volume = 0.8; } catch (e) {} }
    function playHero() { var p = heroVid.play(); if (p && p.catch) p.catch(function () {}); }
    var gEvents = ['pointerdown', 'keydown', 'touchstart', 'wheel', 'click'];
    function onFirstGesture() {
      hadGesture = true;
      if (heroInView) { unmuteHero(); playHero(); }
      gEvents.forEach(function (ev) { window.removeEventListener(ev, onFirstGesture); });
    }
    gEvents.forEach(function (ev) { window.addEventListener(ev, onFirstGesture, { passive: true }); });

    var heroInView = true;
    if (heroEl && 'IntersectionObserver' in window) {
      var hio = new IntersectionObserver(function (es) {
        heroInView = es[0].isIntersecting;
        if (heroInView) { if (hadGesture) unmuteHero(); playHero(); }
        else { heroVid.pause(); }
      }, { threshold: 0.25 });
      hio.observe(heroEl);
    }
  }

  /* ---------- featured add-to-cart ---------- */
  var form = root.querySelector('[data-mc-lg-form]');
  if (form && window.fetch) {
    var btn = form.querySelector('[data-mc-lg-add]');
    var label = form.querySelector('[data-mc-lg-add-label]');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (btn.disabled) return;
      var orig = label.textContent;
      btn.disabled = true; label.textContent = 'adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: form.querySelector('[name=id]').value, quantity: 1 }] })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          btn.classList.add('is-added'); label.textContent = 'added ✓';
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          setTimeout(function () { label.textContent = orig; btn.classList.remove('is-added'); btn.disabled = false; }, 2200);
        })
        .catch(function () { label.textContent = orig; btn.disabled = false; });
    });
  }
})();
